import { Component } from '@angular/core';
import { SecurityData } from '../security-data';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './unsupported.component.html',
  imports: [TranslatePipe]
})
export class UnsupportedComponent {
  constructor(public securityData: SecurityData) {}
}
